module.exports = " <div _v-63ee4518=\"\"> <router-view _v-63ee4518=\"\"></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-63ee4518!./~/vue-loader/lib/selector.js?type=template&index=0!./src/wuyan.vue
// module id = 211
// module chunks = 1